<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
    
    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="7" />
      <div class="box5">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">投诉/建议详情</div>
        </div>
        <div class="box7"></div>
        
        <div class="box12">
          <div class="box13" style="text-align: left;">手机号：<span style="color: #2B9A34;">{{obj.userNum}}</span></div>
          <div class="box13">当前状态：<span style="color: #2B9A34;">{{obj.fettle}}</span></div>
          <div class="box13">更新时间：<span style="color: #2B9A34;">{{obj.updatedAt}}</span></div>
          <router-link to="/my_feedback"><div class="box13" style="text-align: right;">返回列表 ></div></router-link>
        </div>
 
        <!-- <div class="box12">
          <div class="box13" style="text-align: left;"><img src="" class="message_left_img" alt=""></div>
          <div class="box13">          <div class="message_details_title">反馈内容<span style="margin-left: 4%;">反馈类型：<span style="color: #2B9A34;">XXXX</span></span></div>
        </div>
          <div class="box13">更新时间：<span style="color: #2B9A34;">2020-09-28  19:40:24</span></div>
          <div class="box13" style="text-align: right;">返回列表 ></div>
        </div> -->

        <div style="margin-top: 0; background: none; border-top: 1px dashed #EEEEEE; padding: 2% 0 0.5% 0; overflow: hidden;border-bottom: 1px dashed rgb(238, 238, 238);">
          <div style="overflow: hidden;">
            <img :src="'/api/file/preview/'+obj.userAvatar" class="message_left_img" alt="" v-if="obj.userAvatar">
            <div  class="message_left_img" v-else></div>
          <div class="message_details_title" style="margin-left: 5%;">
            <div style="width: 300px; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;float: left;">反馈内容</div>
            <!-- <div style="width: 300px; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;float: left;">{{obj.reply}}</div> -->
            <span style="margin-left: 10%;">反馈类型：<span style="color: #2B9A34;">{{obj.types}}</span></span></div>
          <div class="message_details_time" >{{obj.createdAt}}</div>
          </div>
          <div class="message_details_info" v-html="obj.complaint" style="margin-left:70px;margin-bottom:2px"></div>
        </div>

        <div v-if="obj.reply!==''" style="margin-top: 0; background: none; border-top: 1px dashed #EEEEEE; padding: 2% 0 0.5% 0; overflow: hidden;border-bottom: 1px dashed rgb(238, 238, 238);">
          <div style="overflow: hidden;">
            <img :src="'/api/file/preview/'+obj.replyAvatar" class="message_left_img" alt="" v-if="obj.replyAvatar">
            <div  class="message_left_img" v-else></div>
            
          <div class="message_details_title" style="margin-left: 5%;">
            <div style="width: 300px; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;float: left;">{{obj.replyer}}</div>
            <!-- <div style="width: 300px; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;float: left;">{{obj.reply}}</div> -->
            <span style="margin-left: 10%;"><span style="color: #2B9A34;"></span></span></div>
          <div class="message_details_time" >{{obj.updatedAt}}</div>
          </div>
          <div class="message_details_info" v-html="obj.reply" style="margin-left:70px;margin-bottom:20px"></div>
        </div>


        <a-divider :dashed="true" style="color: #999999;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;">您对以上内容回复是否满意？</a-divider>
        <div style="margin: 4% auto; width: 40%;">
          <a-row :gutter="16">
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <div :class="{comment_but:true,xuanzhong:manyi}" @click="comment(0)">
                  <img src="../assets/fankui/zan1.png" style="width: 14px;" alt="">
                  满意</div>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <div :class="{comment_but:true,xuanzhong:yiban}" @click="comment(1)">
                  <img src="../assets/fankui/zan3.png" style="width: 14px;" alt="">
                  一般</div>
              </div>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <div class="gutter-box">
                <div :class="{comment_but:true,xuanzhong:bumanyi}" @click="comment(2)">
                  <img src="../assets/fankui/zan2.png" style="width: 14px;" alt="">
                  不满意</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
import foot from "../public/foot";
    export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {
              obj: {},
              manyi:false,
              yiban:false,
              bumanyi:false
            };
        },
        methods: {
          // 评价反馈
          comment(e) {
            if(!this.obj.satisfaction){
              let satisfaction
              if(e == 0) {
                satisfaction = '满意'
              }
              if(e == 1) {
                satisfaction = '一般'
              }
              if(e == 2) {
                satisfaction = '不满意'
              }
              this.api.complaint_satisfaction({ complaintId: this.obj.uuid, satisfaction }).then(res => {
                if(res.ok) {
                  this.$message.success(res.message)
                  // this.$router.push('/my_feedback')
                  this.$router.back(-1)
                }else {
                  this.$message.error(res.message)
                }
              })
            }else{
              this.$message.error('请勿重复评价')
            }
          },
          // 评价结果
          jieguo(){
            if(this.obj.satisfaction == '满意'){
              this.manyi =true
            }
            if(this.obj.satisfaction == '一般'){
              this.yiban =true
            }
            if(this.obj.satisfaction == '不满意'){
              this.bumanyi =true
            }
          },
          // 获取详情
          get_complaint_details() {
            this.api.get_complaint_details(this.$route.query.uuid).then(res => {
              if(!res.ok) {
                this.$message.error(res.message)
                return false
              }
              console.log(res.data);
              this.obj = res.data
              this.jieguo()
            })
          }
        },
        created() {
          this.get_complaint_details()
        },
    };
</script>



<style scoped>
  .xuanzhong{
    background: #2C9A34;
  }
  .message_details_info {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #000000;
text-align: left;
margin-top: 2%;

  }
    .message_details_time {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        float: right;
    }
    
    .message_details_title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        /* line-height: 16px; */
        float: left;
        width: 70%;
    }
    
    .message_left_img {
        width: 24px;
        height: 24px;
        background: #E0E0E0;
        border-radius: 50%;
        float: left;
    }
    
    .box14 {
        width: 120px;
        height: 32px;
        border: 1px solid #2C9A34;
        float: right;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2C9A34;
    }
    
    .box13 {
        width: 25%;
        height: 100%;
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
    }
    
    .box12 {
        width: 100%;
        height: 40px;
        /* background: #F4F4F4; */
        margin-top: 4%;
    }
    
    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }
    
    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }
    
    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }
    
    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }
    
    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }
    
    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }
    
.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }
    
    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }
    
    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }
    
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }
    
    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }

    .comment_but {
      text-align: center;
      width: 100px;
height: 32px;
border: 1px solid #EDE9E9;
line-height: 32px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;

cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/complaint_details.vue